import { createSlice } from '@reduxjs/toolkit';
import { ICrop, ISeason } from 'packages/lib-utils';

// Define the TS type for the counter slice's state

export interface AppDetailsState {
  filters: {
    crops: ICrop | null;
    season: ISeason | null;
  };
  pageDetail: {
    title: string;
    status?: string;
    breadCrumbNavigations?: {
      path: string;
      title: string;
    }[];
    isHideBreadcrumbs?: boolean;
  };
  cropsList?: any[];
  seasonsList?: any[];
  userSpecificTeams?: any[];
}

// Define the initial value for the slice state
const initialState: AppDetailsState = {
  filters: {
    crops: null,
    season: null,
  },
  pageDetail: {
    title: '',
    status: '',
  },
  cropsList: [],
  seasonsList: [],
  userSpecificTeams: [],
};

export const appDetailsSlice = createSlice({
  name: 'appDetails',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    resetFilter: (state) => {
      state.filters = initialState.filters;
    },
    setPageDetail: (state, action) => {
      state.pageDetail = action.payload;
    },
    setCropList: (state, action) => {
      state.cropsList = action.payload;
    },
    setSeasonsList: (state, action) => {
      state.seasonsList = action.payload;
    },
    setUserSpecificTeams: (state, action) => {
      state.userSpecificTeams = action.payload;
    },
  },
});

// Export the generated action creators for use in components
export const {
  setFilters,
  resetFilter,
  setPageDetail,
  setCropList,
  setSeasonsList,
  setUserSpecificTeams,
} = appDetailsSlice.actions;

// Export the slice reducer for use in the store configuration
export default appDetailsSlice.reducer;
